export const environment = {
    state: "production",
    baseUrl: "https://malirang.com",
    lpinspection: {
        url: "https://inspection.malirang.com",
    },
};
